export const menu = {
  languageTH: {
    TH: 'ภาษาไทย',
    EN: 'ภาษาไทย'
  },
  languageEN: {
    TH: 'English',
    EN: 'English'
  },
  announcement: {
    TH: 'ประกาศ',
    EN: 'Announcement'
  },
  homeAutomationGateways: {
    TH: 'เครื่อข่ายบ้านอัตโนมัติ',
    EN: 'Home Automation Gateways'
  },
  userProfiles: {
    TH: 'ข้อมูลส่วนตัวผู้ใช้',
    EN: 'User Profiles'
  },
  residents: {
    TH: 'ข้อมูลลูกบ้าน',
    EN: 'Residents'
  },
  projects: {
    TH: 'โครงการ',
    EN: 'Projects'
  },
  messaging: {
    TH: 'การส่งข้อความ',
    EN: 'Messaging'
  },
  serviceRequest: {
    TH: 'บริการคำร้อง',
    EN: 'Service Request'
  },
  oneApp: {
    TH: 'วัน แอพ',
    EN: 'One App'
  },
  docs: {
    TH: 'คู่มือ',
    EN: 'Docs'
  },
  jwt: {
    TH: 'โทเคน',
    EN: 'JWT'
  },
  users: {
    TH: 'ผู้ใช้',
    EN: 'Users'
  },
  oneService: {
    TH: 'วันโอวัน',
    EN: '101 Service'
  },
  index: {
    TH: 'หน้าหลัก',
    EN: 'Index'
  },
  create: {
    TH: 'สร้าง',
    EN: 'Create'
  },
  addResident: {
    TH: 'เพิ่มลูกบ้าน',
    EN: 'Add Resident'
  },
  addProject: {
    TH: 'เพิ่มลูกบ้าน',
    EN: 'Add Project'
  },
  setting: {
    TH: 'ตั้งค่า',
    EN: 'Setting'
  },
  history: {
    TH: 'ประวัติ',
    EN: 'History'
  },
  registerUser: {
    TH: 'ลงทะเบียนผู้ใช้',
    EN: 'register user'
  },
  permission: {
    TH: 'การเข้าถึง',
    EN: 'permission'
  },
  appList: {
    TH: 'รายชื่อแอพ',
    EN: 'App List'
  },
  createApp: {
    TH: 'สร้างแอพ',
    EN: 'Create App'
  },
  apiKey: {
    TH: 'เอพีไอเคย์',
    EN: 'API Key'
  },
  userToken: {
    TH: 'โทเคนผู้ใช้',
    EN: 'User Token'
  },
  sendNotification: {
    TH: 'ส่งการแจ้งเตือน',
    EN: 'Send Notification'
  }
};

export const home = {
  welcome: {
    TH: 'ยินดีต้อนรับเข้าสู่เว็ปไซต์แอดมิน',
    EN: 'Welcome to Admin Console'
  },
  doc: {
    TH: 'เอกสารคู่มือการใช้งาน',
    EN: 'Documentration'
  }
};

export const announcement = {
  index: {
    TH: 'ดัชนี',
    EN: 'index'
  },
  create: {
    TH: 'สร้าง',
    EN: 'create'
  },
  announcementList: {
    TH: 'รายการประกาศ',
    EN: 'Announcement list'
  },
  announcementForm: {
    TH: 'แบบฟอร์มประกาศ',
    EN: 'Announcement Form'
  },
  filter: {
    TH: 'ตัวกรอง',
    EN: 'filter'
  },
  activity: {
    TH: 'กิจกรรม',
    EN: 'activity'
  },
  thumbnail: {
    TH: 'รูปขนาดย่อ',
    EN: 'thumbnail'
  },
  createdDate: {
    TH: 'วันที่สร้าง',
    EN: 'created date'
  },
  type: {
    TH: 'ประเภท',
    EN: 'type'
  },
  topic: {
    TH: 'หัวข้อ',
    EN: 'topic'
  },
  publish: {
    TH: 'เผยแพร่',
    EN: 'publish'
  },
  browse: {
    TH: 'เลือก',
    EN: 'browse'
  },
  setDefault: {
    TH: 'ตั้งค่าเริ่มต้น',
    EN: 'set default'
  },
  chooseThumbnailFile: {
    TH: 'เลือกรูปขนาดย่อ',
    EN: 'choose thumbnail file'
  },
  pleaseSelectTypeOfAnnouncement: {
    TH: 'โปรดเลือกประเภทของประกาศ',
    EN: 'please select type of announcement'
  },
  project: {
    TH: 'โครงการ',
    EN: 'project'
  },
  pleaseSelectProject: {
    TH: 'โปรดเลือกโครงการ',
    EN: 'please select project'
  },
  pleaseEnterTopic: {
    TH: 'โปรดใส่หัวข้อ',
    EN: 'please enter topic'
  },
  content: {
    TH: 'เนื้อหา',
    EN: 'content'
  },
  contentOfTheEditor: {
    TH: 'โปรดใส่เนื้อหา',
    EN: 'content of the editor'
  },
  urlAddress: {
    TH: 'ที่อยู่ URL',
    EN: 'url address'
  },
  pleaseEnterUrlAddress: {
    TH: 'โปรดใส่ที่อยู่ URL',
    EN: 'please enter url address'
  },
  banner: {
    TH: 'แบนเนอร์',
    EN: 'banner'
  },
  showAsSliding: {
    TH: 'แสดงแบนเนอร์แบบเลื่อนด้านบนของแอปพลิเคชั่น',
    EN: 'Show as sliding banner at the top of application'
  },
  clickShow: {
    TH: 'กดเพื่อแสดง',
    EN: 'click show'
  },
  clickHide: {
    TH: 'กดเพื่อซ่อน',
    EN: 'click hide'
  },
  addImage: {
    TH: 'เพิ่มรูปภาพ',
    EN: 'add image'
  },
  back: {
    TH: 'กลับ',
    EN: 'back'
  },
  draft: {
    TH: 'แบบร่าง',
    EN: 'draft'
  },
  delete: {
    TH: 'ลบ',
    EN: 'delete'
  },
  shouldSaveBefore: {
    TH: 'แจ้งเตือน: กดบันทึกก่อนเผยแพร่ หรือ ส่งข้อความแจ้งเตือนถ้ามีการอัพเดตเนื้อหา',
    EN: 'Warning: should save before publish or send notification if have any update content'
  },
  title: {
    TH: 'ชื่อเรื่อง',
    EN: 'title'
  },
  message: {
    TH: 'ข้อความ',
    EN: 'message'
  },
  platform: {
    TH: 'แพรตฟอร์ม',
    EN: 'platform'
  },
  sendNotification: {
    TH: 'ส่งข้อความแจ้งเตือน',
    EN: 'send notification'
  },
  send: {
    TH: 'ส่ง',
    EN: 'send'
  },
  docs: {
    TH: 'คู่มือ',
    EN: 'docs'
  },
  confirmToDelete: {
    TH: 'ยืนยันการลบ ?',
    EN: 'confirm to delete'
  },
  confirmToCancel: {
    TH: 'ยืนยันการยกเลิก',
    EN: 'confirm to cancel'
  },
  notificationWarning: {
    TH: 'ข้อควรระวัง: ทุกครั้งที่ต้องการส่งข้อความจะต้องทำการบันทึกก่อน',
    EN: 'Warning: should save before publish or send notification if have any update content '
  },
  all: {
    TH: 'ทั้งหมด',
    EN: 'All'
  },
  to: {
    TH: 'ถึง',
    EN: 'To'
  },
  pleaseInsertValues: {
    TH: 'โปรดกรอกข้อมูล',
    EN: 'please insert values'
  },
  immediately: {
    TH: 'ส่งทันที',
    EN: 'immediately'
  },
  setTimer: {
    TH: 'ตั้งเวลา',
    EN: 'set timer'
  },
  close: {
    TH: 'ปิด',
    EN: 'close'
  },
  publishAndSendNotification: {
    TH: 'เผยแพร่และส่งการแจ้งเตือน',
    EN: 'Publish and Send Notification'
  },
  seeMoreDetails: {
    TH: 'ดูรายละเอียดเพิ่มเติม',
    EN: 'see more details'
  },
  cancelTimer: {
    TH: 'ยกเลิกการตั้งเวลาเผยแพร่',
    EN: 'cancel to set timer'
  },
  cancelTimerSuccess: {
    TH: 'ยกเลิกการตั้งเวลาในการส่งข้อความสำเร็จ',
    EN: 'Cancel publish set timming successfully'
  },
  publishSuccess: {
    TH: 'การส่งเผยแพร่ประกาศสำเร็จแล้ว',
    EN: 'Publish announcement successfully.'
  },
  cancelPublishIn: {
    TH: 'ยกเลิกการเผยแพร่ภาพใน',
    EN: 'Cancel for publishing in'
  }
};

export const common = {
  confirm: {
    TH: 'ยืนยัน',
    EN: 'confirm'
  },
  close: {
    TH: 'ปิด',
    EN: 'close'
  }
};

export const gateway = {
  gatewayStatus: {
    TH: 'สถานะเกตเวย์',
    EN: 'Gateway statuses'
  },
  unit: {
    TH: 'ยูนิต',
    EN: 'Unit'
  },
  url: {
    TH: 'Url',
    EN: 'Url'
  },
  port: {
    TH: 'พอร์ต',
    EN: 'Port'
  },
  status: {
    TH: 'สถานะ',
    EN: 'Status'
  },
  check: {
    TH: 'เชค',
    EN: 'check'
  },
  connectionUnsuccessful: {
    TH: 'การเชื่อมต่อล้มเหลว!',
    EN: 'Connection Unsuccessful!'
  },
  close: {
    TH: 'ปิด',
    EN: 'Close'
  },
  offline: {
    TH: 'ออฟไลน์',
    EN: 'Offline'
  },
  connectionSuccessfullAndOnline: {
    TH: 'การชื่อต่อสำเร็จและกำลังออนไลน์อยู่',
    EN: 'connection successfull and online'
  }
};

export const userProfiles = {
  oneAppUsers: {
    TH: 'ผู้ใช้งานวันแอพ',
    EN: 'One app users'
  },
  enterKeyword: {
    TH: 'โปรดใส่ คีย์เวริด และกด Enter',
    EN: 'Enter keyword and press enter'
  },
  loading: {
    TH: 'กำลังโหลด....',
    EN: 'loading...'
  },
  firstName: {
    TH: 'ชื่อ',
    EN: 'FirstName'
  },
  lastName: {
    TH: 'นามสกุล',
    EN: 'LastName'
  },
  email: {
    TH: 'อีเมลล์',
    EN: 'email'
  },
  verifiedAccount: {
    TH: 'ตรวจสอบผู้ใช้',
    EN: 'Verified Account'
  },
  status: {
    TH: 'สถานะ',
    EN: 'Status'
  },
  createdAt: {
    TH: 'สร้างเมื่อ',
    EN: 'Created At'
  },
  updatedAt: {
    TH: 'อัพเดรตเมื่อ',
    EN: 'Updated At'
  },
  oneAppUserProfile: {
    TH: 'วันแอพ: ข้อมูลผู้ใช้',
    EN: 'One App: user profile'
  },
  chooseProfilePicture: {
    TH: 'เลือกรูปผู้ใช้',
    EN: 'choose profile picture'
  },
  middleName: {
    TH: 'ชื่อกลาง',
    EN: 'Middle Name'
  },
  mobile: {
    TH: 'เบอร์มือถือ',
    EN: 'Mobile'
  },
  idCard: {
    TH: 'เลขบัตรประชาชน / เลขที่หนังสือเดินทาง',
    EN: 'ID Card No./Passport'
  },
  userVerifiedAt: {
    TH: 'ตรวจสอบผู้ใช้เมื่อ',
    EN: 'User Verified At'
  },
  userStatus: {
    TH: 'สถานะผู้ใช้',
    EN: 'User status'
  },
  active: {
    TH: 'เปิดใช้งาน',
    EN: 'Active'
  },
  notActive: {
    TH: 'ไม่มีการใช้งาน',
    EN: 'Not Active'
  },
  verify: {
    TH: 'ยืนยันตัวตน',
    EN: 'verify'
  },
  update: {
    TH: 'อัพเดรต',
    EN: 'Update'
  },
  addProject: {
    TH: 'เพิ่มโครงการ',
    EN: 'Add Project'
  },
  ownerProjects: {
    TH: 'โครงการที่เป็นเจ้าของ',
    EN: 'Owner Projects'
  },
  activateDeactivate: {
    TH: 'เปิด/ปิด การใช้งาน',
    EN: 'Activate/Deactivate'
  },
  project: {
    TH: 'โครงการ',
    EN: 'Project'
  },
  pleaseSelect: {
    TH: 'โปรดเลือก',
    EN: 'Please Select'
  },
  save: {
    TH: 'บันทึก',
    EN: 'Save'
  },
  back: {
    TH: 'กลับ',
    EN: 'Back'
  },
  addUnit: {
    TH: 'เพิ่มยูนิต',
    EN: 'Add Unit'
  },
  addUnitToProject: {
    TH: 'เพิ่มยูนิตไปยังโครงการ',
    EN: 'Add unit to project'
  },
  deleteProject: {
    TH: 'ลบโครงการ',
    EN: 'Delete Project'
  },
  deleteProjectTitle: {
    TH: 'ลบผู้ใช้ออกจากโครงการ',
    EN: 'Delete user from the project'
  },
  unitNumber: {
    TH: 'บ้านเลขที่',
    EN: 'House Number'
  },
  gateway: {
    TH: 'เกตเวย์',
    EN: 'Gateway'
  },
  port1: {
    TH: 'พอร์ต1',
    EN: 'Port1'
  },
  port2: {
    TH: 'พอร์ต2',
    EN: 'Port2'
  },
  actions: {
    TH: 'ค่ำสั่ง',
    EN: 'Actions'
  },
  edit: {
    TH: 'แก้ไข',
    EN: 'Edit'
  },
  hide: {
    TH: 'ซ่อน',
    EN: 'Hide'
  },
  pleaseConfirm: {
    TH: 'โปรดยืนยัน',
    EN: 'Please confirm.'
  },
  askDeleteProject: {
    TH: 'คุณยืนยันที่จะลบโปรเจคของผุ้ใช้นี้จริงหรือไม่ ?',
    EN: 'Are you sure to delete this Project?'
  },
  yes: {
    TH: 'ใช่',
    EN: 'Yes'
  },
  no: {
    TH: 'ไม่',
    EN: 'No'
  },
  userUpdateSuccessMessage: {
    TH: 'อัพเดรตข้อมูลผู้ใช้สำเร็จแล้ว!',
    EN: 'Updated user information successfully!'
  },
  userUpdateErrorMessage: {
    TH: 'เกิดข้อผิดพลาดในการอัพเดรตข้อมูล',
    EN: 'Error updating user information.'
  },
  confirmUserUpdateMessage: {
    TH: 'คุณยืนยันที่จะอัพเดรตข้อมูลผู้ใช้จริงหรือไม่?',
    EN: 'Are you sure to update user information?'
  },
  uploadAvatarErrorMessage: {
    TH: 'เกิดข้อผิดพลาดในการอัพโหลดรูปตัวแทน',
    EN: 'Error uploading avatar.'
  },
  removeAvatarWarning: {
    TH: 'คุณยืนยันที่จะลบรูปตัวแทนจริงหรือไม่?',
    EN: 'Are you sure to remove avatar?'
  },
  removeAvatarSuccess: {
    TH: 'ลบรูปตัวแทนสำเร็จแล้ว',
    EN: 'Removed avatar successfully.'
  },
  deleteUnitWarning: {
    TH: 'คุณยืนยันที่จะลบยูนิตจริงหรือไม่?',
    EN: 'Are you sure to delete this Unit?'
  },
  deleteUnitSuccess: {
    TH: 'ลบยูนิตสำเร็จแล้ว',
    EN: 'Deleted Unit successfully.'
  },
  deleteProjectSuccess: {
    TH: 'ลบโปรเจคสำเร็จแล้ว',
    EN: 'Deleted Project successfully.'
  },
  grantWarning: {
    TH: 'คุณยืนยันที่จะอนุญาตผู้ใช้เข้าถึงยูนิดนี้จริงหรือไม่?',
    EN: 'Are you sure to grant access to this Unit?'
  },
  revokeWarning: {
    TH: 'คุณยืนยันที่จะยกเลิกการเข้าถึงยูนิดนี้จริงหรือไม่?',
    EN: 'Are you sure to revoke access to this Unit?'
  },
  grantSuccess: {
    TH: 'อนุญาตการเข้าถึงแล้ว',
    EN: 'Access has been granted.'
  },
  revokeSuccess: {
    TH: 'ยกเลิกการเข้าถึงแล้ว',
    EN: 'Access has been revoked.'
  },
  wrongFormatMobileNumber: {
    TH: 'เบอร์มือถือไม่ถูกต้อง ตัวอย่างที่ถูกต้อง "080-XXX-XXX"',
    EN: 'Wrong format mobile number, example "080-XXX-XXXX"'
  },
  add: {
    TH: 'เพิ่ม',
    EN: 'Add'
  },
  userType: {
    TH: 'ประเภทผู้ใช้',
    EN: 'User Type'
  },
  tenant: {
    TH: 'ผู้เช่า',
    EN: 'tenant'
  },
  owner: {
    TH: 'เจ้าของ',
    EN: 'owner'
  }
};

export const resident = {
  importExcel: {
    TH: 'นำเข้าไฟล์ (เอ็กเซล)',
    EN: 'Import (Excel)'
  },
  enterSearch: {
    TH: 'ใส่คำที่ต้องการค้นหา แล้วกดเอ็นเทอร์',
    EN: 'Enter keyword and press enter'
  },
  email: {
    TH: 'อีเมลล์',
    EN: 'Email'
  },
  mobile: {
    TH: 'เบอร์มือถือ',
    EN: 'Mobile'
  },
  firstName: {
    TH: 'ชื่อ',
    EN: 'FirstName'
  },
  middleName: {
    TH: 'ชื่อกลาง',
    EN: 'MiddleName'
  },
  lastName: {
    TH: 'นามสกุล',
    EN: 'LastName'
  },
  idCard: {
    TH: 'หมายเลขบัตรประชาชน',
    EN: 'idCard'
  },
  editable: {
    TH: 'สามารถแก้ไข',
    EN: 'Editable'
  },
  createdAt: {
    TH: 'สร้างเมื่อ',
    EN: 'Created At'
  },
  updatedAt: {
    TH: 'อัพเดรตเมื่อ',
    EN: 'Updated At'
  },
  addResident: {
    TH: 'เพิ่มลูกบ้าน',
    EN: 'Add Resident'
  },
  editResident: {
    TH: 'แก้ไขลูกบ้าน',
    EN: 'Edit Resident'
  },
  deleteResident: {
    TH: 'ลบลูกบ้าน',
    EN: 'Delete Resident'
  },
  idCardAndPassport: {
    TH: 'เลขบัตรประชาชน / เลขที่หนังสือเดินทาง',
    EN: 'ID Card No./Passport'
  },
  save: {
    TH: 'บันทึก',
    EN: 'Save'
  },
  verify: {
    TH: 'ยืนยันตัวตน',
    EN: 'Verify'
  },
  addProjectBtnCaption: {
    TH: 'เพิ่มโครงการให้ลูกบ้าน',
    EN: 'Add Project to Resident'
  },
  projects: {
    TH: 'โครงการ',
    EN: 'Projects'
  },
  addUnit: {
    TH: 'เพิ่มยูนิต',
    EN: 'Add Unit'
  },
  deleteProject: {
    TH: 'ลบโครงการ',
    EN: 'Delete Project'
  },
  actions: {
    TH: 'ค่ำสั่ง',
    EN: 'Actions'
  },
  saveSuccessMessage: {
    TH: 'บันทึกข้อมูลสำเร็จแล้ว!',
    EN: 'Successfully saved!'
  },
  updateSuccessMessage: {
    TH: 'อัพเดรตข้อมูลสำเร็จแล้ว!',
    EN: 'Successfully updated!'
  },
  deleteUnitWarning: {
    TH: 'คุณยืนยันที่จะลบยูนิตจริงหรือไม่?',
    EN: 'Are you sure to delete this Unit?'
  },
  deleteUnitSuccess: {
    TH: 'ลบยูนิตสำเร็จแล้ว',
    EN: 'Deleted Unit successfully.'
  },
  deleteProjectWarning: {
    TH: 'คุณยืนยันที่จะลบโครงการนี้จริงหรือไม่?',
    EN: 'Are you sure to delete this Project?'
  },
  deleteProjectSuccess: {
    TH: 'ลบโปรเจคสำเร็จแล้ว',
    EN: 'Deleted Project successfully.'
  },
  deleteResidentWarning: {
    TH: 'คุณยืนยันที่จะลบลูกบ้านนี้จริงหรือไม่',
    EN: 'Are you sure to delete this resident?'
  },
  deleteResidentSuccess: {
    TH: 'ลบลูกบ้านสำเร็จแล้ว',
    EN: 'Resident has been deleted successfully.'
  },
  pleaseConfirm: {
    TH: 'โปรดยืนยัน!',
    EN: 'Please Confirm.!'
  },
  yes: {
    TH: 'ใช่',
    EN: 'Yes'
  },
  no: {
    TH: 'ไม่',
    EN: 'No'
  },
  unit: {
    TH: 'ยูนิต',
    EN: 'Unit'
  },
  unitNumber: {
    TH: 'บ้านเลขที่',
    EN: 'House number'
  },
  back: {
    TH: 'กลับ',
    EN: 'Back'
  },
  updateUnit: {
    TH: 'อัพเดรตยูนิต',
    EN: 'Update Unit'
  },
  deleteUnit: {
    TH: 'ลบยูนิต',
    EN: 'Delete Unit'
  },
  residentType: {
    TH: 'ประเภทผู้ใช้',
    EN: 'Resident Type'
  }
};

export const project = {
  name: {
    TH: 'ชื่อ',
    EN: 'Name'
  },
  contactEmail: {
    TH: 'อีเมลล์',
    EN: 'Email'
  },
  code: {
    TH: 'Code',
    EN: 'Code'
  },
  phoneNumber: {
    TH: 'หมายเลขโทรศัพท์',
    EN: 'Phone Number'
  },
  juristicNumber: {
    TH: 'Juristic Phone Number',
    EN: 'Juristic Phone Number'
  },
  createdAt: {
    TH: 'สร้างเมื่อ',
    EN: 'Created At'
  },
  updatedAt: {
    TH: 'อัพเดรตเมื่อ',
    EN: 'Updated At'
  },
  save: {
    TH: 'บันทึก',
    EN: 'Save'
  },
  verify: {
    TH: 'ยืนยันตัวตน',
    EN: 'Verify'
  },
  actions: {
    TH: 'ค่ำสั่ง',
    EN: 'Actions'
  },
  saveSuccessMessage: {
    TH: 'บันทึกข้อมูลสำเร็จแล้ว!',
    EN: 'Successfully saved!'
  },
  updateSuccessMessage: {
    TH: 'อัพเดรตข้อมูลสำเร็จแล้ว!',
    EN: 'Successfully updated!'
  },
  deleteUnitWarning: {
    TH: 'คุณยืนยันที่จะลบยูนิตจริงหรือไม่?',
    EN: 'Are you sure to delete this Unit?'
  },
  deleteUnitSuccess: {
    TH: 'ลบยูนิตสำเร็จแล้ว',
    EN: 'Deleted Unit successfully.'
  },
  deleteProjectWarning: {
    TH: 'คุณยืนยันที่จะลบโครงการนี้จริงหรือไม่?',
    EN: 'Are you sure to delete this Project?'
  },
  deleteProjectSuccess: {
    TH: 'ลบโปรเจคสำเร็จแล้ว',
    EN: 'Deleted Project successfully.'
  },
  pleaseConfirm: {
    TH: 'โปรดยืนยัน!',
    EN: 'Please Confirm.!'
  },
  yes: {
    TH: 'ใช่',
    EN: 'Yes'
  },
  no: {
    TH: 'ไม่',
    EN: 'No'
  },
  unit: {
    TH: 'ยูนิต',
    EN: 'Unit'
  },
  unitNumber: {
    TH: 'บ้านเลขที่',
    EN: 'House number'
  },
  back: {
    TH: 'กลับ',
    EN: 'Back'
  },
  updateUnit: {
    TH: 'อัพเดรตยูนิต',
    EN: 'Update Unit'
  },
  deleteUnit: {
    TH: 'ลบยูนิต',
    EN: 'Delete Unit'
  },
  deleteProject: {
    TH: 'Delete',
    EN: 'Delete'
  },
  deleteBackground: {
    TH: 'Delete Background',
    EN: 'Delete Background'
  },
  newProject: {
    TH: 'โครงการใหม่',
    EN: 'New Project'
  },
  editProject: {
    TH: 'แก้ไขโครงการ',
    EN: 'Edit Project'
  }
};

export const oneAppMessaging = {
  notificationOneAppForm: {
    TH: 'แบบฟอร์มการแจ้งเตือนวันแอพ',
    EN: ' Notification One App Form '
  },
  docs: {
    TH: 'คู่มือ',
    EN: 'Docs'
  },
  title: {
    TH: 'ชื่อเรื่อง',
    EN: 'title'
  },
  pleaseEnterTitle: {
    TH: 'โปรดใส่หัวข้อ',
    EN: 'please enter title'
  },
  message: {
    TH: 'ข้อความ',
    EN: 'message'
  },
  pleaseEnterMessage: {
    TH: 'โปรดใส่ข้อความ',
    EN: 'please enter message'
  },
  platform: {
    TH: 'แพรตฟอร์ม',
    EN: 'platform'
  },
  to: {
    TH: 'ถึง',
    EN: 'To'
  },
  back: {
    TH: 'กลับ',
    EN: 'Back'
  },
  sendNow: {
    TH: 'ส่งตอนนี้',
    EN: 'Send Now'
  },
  pleaseInsertValues: {
    TH: 'โปรดกรอกข้อมูล',
    EN: 'please insert values'
  },
  seeMoreDetails: {
    TH: 'ดูรายละเอียดเพิ่มเติม',
    EN: 'see more details'
  },
  sendNotificationSuccess: {
    TH: 'ส่งการแจ้งเตือนสำเร็จแล้ว!',
    EN: 'Send notification successfully,'
  },
  sendNotification: {
    TH: 'ส่งข้อความแจ้งเตือน',
    EN: 'send notification'
  },
  oneAppMessagingSetting: {
    TH: 'การต้องค่าการส่งแจ้งเตือนวันแอพ',
    EN: 'One App Messaging Setting '
  },
  mqdcOneApp: {
    TH: 'เลือกเอ็มคิวดีซีวันแอพ',
    EN: 'MQDC One App'
  },
  save: {
    TH: 'บันทึก',
    EN: 'Save'
  },
  oneAppNotificationHistory: {
    TH: 'ประวัติการส่งแจ้งเตือนวันแอพ',
    EN: 'One App Notification History '
  },
  filter: {
    TH: 'กรอง',
    EN: 'Filter'
  },
  pleaseEnterFilter: {
    TH: 'โปรดใส่อีเมลล์หรือโครงการหรือหัวข้อ',
    EN: 'please enter email or project or topic'
  },
  topic: {
    TH: 'หัวข้อ',
    EN: 'Topic'
  },
  time: {
    TH: 'เวลา',
    EN: 'Time'
  },
  destination: {
    TH: 'ปลายทางผู้รับ',
    EN: 'Destination'
  },
  notificationDetails: {
    TH: 'รายละเอียดการแจ้งเตือน',
    EN: 'Notification Details'
  },
  description: {
    TH: 'รายละเอียด',
    EN: 'Description'
  },
  sendTo: {
    TH: 'ส่งถึง',
    EN: 'Send To'
  },
  type: {
    TH: 'ประเภทการส่ง',
    EN: 'Type'
  },
  close: {
    TH: 'ปิด',
    EN: 'Close'
  },
  delete: {
    TH: 'ลบ',
    EN: 'Delete'
  }
};

export const serviceRequest = {
  seviceRequestList: {
    TH: 'รายการบริการคำร้อง',
    EN: 'Service request list '
  },
  docs: {
    TH: 'คู่มือ',
    EN: 'Docs'
  },
  filter: {
    TH: 'ตัวกรอง',
    EN: 'filter'
  },
  pleaseEnterFilter: {
    TH: 'โปรดกรอกอีเมล หรือประเภท หรือหมายเลขเคสในการกรอง',
    EN: 'Please enter email or type, case number to filter'
  },
  email: {
    TH: 'อีเมลล์',
    EN: 'email'
  },
  type: {
    TH: 'ประเภท',
    EN: 'type'
  },
  timeRequest: {
    TH: 'เวลาที่ร้องงขอ',
    EN: 'Time Request'
  },
  caseNumber: {
    TH: 'หมายเลขเคส',
    EN: 'Case Number'
  },
  status: {
    TH: 'สถานะ',
    EN: 'Status'
  }
};

export const user = {
  userList: {
    TH: 'รายชื่อผู้ใช้',
    EN: 'User List'
  },
  filter: {
    TH: 'ตัวกรอง',
    EN: 'Filter'
  },
  filterUsernameOrFullname: {
    TH: 'โปรดกรอกชื่อผู้ใช้หรือชื่อเต็ม',
    EN: 'Please enter username or fullname'
  },
  filterPermission: {
    TH: 'ตัวกรองการเข้าถึง',
    EN: 'Filter permission'
  },
  filterStatus: {
    TH: 'ตัวกรองสถานะ',
    EN: 'Filter status'
  },
  docs: {
    TH: 'คู่มือ',
    EN: 'docs'
  },
  avatar: {
    TH: 'รูปตัวแทน',
    EN: 'Avatar'
  },
  username: {
    TH: 'ชื่อผู้ใช้',
    EN: 'Username'
  },
  fullname: {
    TH: 'ชื่อเต็ม',
    EN: 'Fullname'
  },
  permission: {
    TH: 'การเข้าถึง',
    EN: 'Permission'
  },
  status: {
    TH: 'สถานะ',
    EN: 'Status'
  },
  formRegisterUser: {
    TH: 'แบบฟอร์มลงทะเบียนผู้ใช้',
    EN: 'Form Register User'
  },
  chooseThumbnailFile: {
    TH: 'เลือกรูปขนาดย่อ',
    EN: 'choose thumbnail file'
  },
  setDefault: {
    TH: 'ตั้งค่าเริ่มต้น',
    EN: 'set default'
  },
  usernameEmail: {
    TH: 'ชื่อผู้ใช้, อีเมลล์',
    EN: 'Username, Email'
  },
  pleaseInsertUsernameOrEmail: {
    TH: 'โปรดกรอกชื่อผู้ใช้หรืออีเมลล์',
    EN: 'Please insert username or email'
  },
  pleaseInsertFullname: {
    TH: 'โปรดกรอกชื่อเต็ม',
    EN: 'Please insert fullname'
  },
  pleaseSelectPermissionsOfUser: {
    TH: 'โปรดเลือกการเข้าถึงให้ผู้ใช้',
    EN: 'Please select permissions of user'
  },
  active: {
    TH: 'เปิดใช้งาน',
    EN: 'Active'
  },
  suspend: {
    TH: 'ปิดใช้งาน',
    EN: 'Suspend'
  },
  registerType: {
    TH: 'ประเภทการลงทะเบียน',
    EN: 'Register Type'
  },
  directly: {
    TH: 'ลงทะเบียนโดยตรง',
    EN: 'directly'
  },
  firebase: {
    TH: 'ลงทะเบียนด้วยไฟเบส',
    EN: 'firebase'
  },
  password: {
    TH: 'รหัสผ่าน',
    EN: 'Password'
  },
  pleaseInsertPassword: {
    TH: 'โปรดกรอกรหัสผ่าน',
    EN: 'Please insert password'
  },
  confirmPassword: {
    TH: 'ยืนยันรหัสผ่าน',
    EN: 'Confirm Password'
  },
  pleaseInsertConfirmPassword: {
    TH: 'โปรดกรอกเพื่อยืนยันรหัสผ่าน',
    EN: 'Please insert confirm password'
  },
  back: {
    TH: 'กลับ',
    EN: 'back'
  },
  save: {
    TH: 'บันทึก',
    EN: 'save'
  },
  delete: {
    TH: 'ลบ',
    EN: 'delete'
  },
  permissionList: {
    TH: 'รายชื่อการเข้าถึง',
    EN: 'Permission List'
  },
  permissionName: {
    TH: 'ชื่อการเข้าถึง',
    EN: 'Permission Name'
  },
  add: {
    TH: 'เพิ่ม',
    EN: 'Add'
  },
  pleaseInsertPermission: {
    TH: 'โปรดใส่การเข้าถึง',
    EN: 'Please Insert Permission'
  },
  history: {
    TH: 'ประวัติ',
    EN: 'History'
  }
};
